
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: 'app',
data(){
return{
transitionName:'fade-in'
}
},
watch:{
'$route'(to,from){
let vm = this;
const toDepth = to.path.split('/').length;
const fromDepth = from.path.split('/').length;
if(toDepth == fromDepth){
vm.transitionName = '';
}else{
vm.transitionName = toDepth < fromDepth ? 'fade-in':'fade-out';
}
},
},
components:{
Tabbar,
TabbarItem,
XHeader
}
};



// WEBPACK FOOTER //
// ./src/App.vue